import "../styles/Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <p>© 2026 Brindha Ajay. All rights reserved.</p>

      <p>Built using React.js</p>
    </footer>
  );
}

export default Footer;
